
























import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { stripNewLine } from '@/utils/string';
import PhotoUploadAdapterGenerator from '@/components/proff/utils/ckeditor/photo-upload-adapter-generator';
import NotificationsExtension from '@/components/proff/utils/ckeditor/notifications-extension';
import E2EMixin from '@/components/mixins/E2EMixin';
import { highlightOptions } from '@/components/proff/utils/ckeditor/highlight';
import { ValidationProvider } from 'vee-validate';
import { ValidatorProps } from '@/../types/validator';

export default mixins(E2EMixin).extend({
  components: {
    ckeditor: CKEditor.component,
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    asyncFileUpload: {
      type: Function,
      required: true,
    },
    validator: {
      type: Object as PropType<ValidatorProps>,
      default: () => ({ name: undefined, rules: undefined }),
    },
  },
  data() {
    return {
      innerValue: stripNewLine(this.value),
      editor: ClassicEditor,
      editorConfig: {
        language: 'ja',
        extraPlugins: [
          PhotoUploadAdapterGenerator(async image => {
            const url = await this.asyncFileUpload(image);
            return { default: url };
          }),
          NotificationsExtension(),
        ],
        mediaEmbed: {
          previewsInData: true,
        },
      },
      highlight: {
        options: highlightOptions,
      },
    };
  },
  computed: {
    provider(): InstanceType<typeof ValidationProvider> {
      return this.$refs.provider;
    },
  },
  methods: {
    handleInput(value) {
      this.innerValue = value;
      this.$emit('input', value);
    },
  },
});
